var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagramB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.31,25H66.69A44.74,44.74,0,0,0,22,69.72v60.63A44.72,44.72,0,0,0,66.69,175h60.62A44.72,44.72,0,0,0,172,130.35V69.72A44.74,44.74,0,0,0,127.31,25Zm29.6,105.32a29.59,29.59,0,0,1-29.59,29.59H66.69a29.59,29.59,0,0,1-29.6-29.58h0V69.72a29.6,29.6,0,0,1,29.6-29.6h60.62a29.6,29.6,0,0,1,29.6,29.6h0v60.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97,61.24A38.8,38.8,0,1,0,135.8,100v0A38.84,38.84,0,0,0,97,61.24Zm0,62.5A23.71,23.71,0,1,1,120.71,100,23.72,23.72,0,0,1,97,123.74Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.87,
    cy: 61.53,
    r: 9.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramB);
export default __webpack_public_path__ + "static/media/instagramB.eeff0183ca6c3512b11eb574badc8032.svg";
export { ForwardRef as ReactComponent };